import React, { useState, useEffect, useRef } from "react";
import { useAllOrderStore } from "./store";
import { get, isEmpty } from "lodash";
import {
  getValue,
  getLineItemsName,
  getSubscriptionPlatform,
  isDownloadDisabled,
} from "modules/utilities/utility";
import { useLocation, useNavigate } from "react-router-dom";
import ShowCustomer from "modules/dashboards/actionables/ShowCustomer";
import { Row, Col } from "react-bootstrap";
import { Popover, Tag } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import moment from "moment";
import PaginationDiv from "modules/pagination/PaginationDiv";
import CardDiv from "modules/common/card-div/CardDiv";
import { Button } from "react-bootstrap";
import AssignedOrderFilter from "modules/dashboards/actionables/AssignedOrderFilter";
import { useToast } from "modules/navbar/top/store/toasterStore";
import AllOrderAssign from "./AllOrderAssign";
import PlaceHolderActionable from "modules/dashboards/actionables/PlaceHolderActionable";
import SelectDataToDisplay from "assets/svgs/no_data_icon/SelectDataToDisplay";


function AllOrdersManagement() {
  const [data, setData] = useState("");
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const [showCustomerInFull, setShowCustomerInFull] = useState(false);
  const [docData, setDocData] = useState(null);
  const [activeId, setActiveId] = useState(null);
  const [queryParams, setQueryParams] = useState("");
  const [page, newPage] = useState(1);
  const [assign, setAssign] = useState("");
  const [allFlag, setAllFlag] = useState(false);
  const [countAssign, setCountAssign] = useState(0);
  const [show, setShow] = useState(false);
  const [initialRender, setInitialRender] = useState(true);
  const [loadComponent, setLoadComponent] = useState(false);

  const target = useRef(null);
  const {
    ordersData,
    medicalData,
    consultData,
    operationData,
    ordersLoading,
    fetchAllOrder,
    fetchMedicalRep,
    fetchConsultRep,
    fetchOperations,
    fetchOrderDownload,
    postAssignData,
  } = useAllOrderStore();
  const { setToaster } = useToast();
  const pageData = Number(searchParams.get("pageNumber")) || 1;
  const startDate = searchParams.get("startDate");
  const endDate = searchParams.get("endDate");
  const bulk = searchParams.get("isBulk");
  const subscription = searchParams.get("isSubscription");
  const status = searchParams.get("status");
  const subStatus = searchParams.get("subStatus");
  const doctor = searchParams.get("doctors");
  const orderSource = searchParams.get("orderSource");
  const owner = searchParams.get("assignedTo");
  const repeat = searchParams.get("orderType");
  const orderType = searchParams.get("orderSourceType");
  const combo = searchParams.get("isCombo");
  useEffect(() => {
    const queryParamsMap = {
      startDate: startDate && `&startDate=${startDate}`,
      endDate: endDate && `&endDate=${endDate}`,
      isBulk: bulk && `&isBulk=${bulk}`,
      isSubscription: subscription && `&isSubscription=${subscription}`,
      status: status && `&status=${status}`,
      subStatus: subStatus && `&subStatus=${subStatus}`,
      doctors: doctor && `&doctors=${doctor}`,
      orderSource: orderSource && `&orderSource=${orderSource}`,
      orderType: repeat && `&orderType=${repeat}`,
      assignedTo: owner && `&assignedTo=${owner}`,
      orderSourceType: orderType && `&orderSourceType=${orderType}`,
      isCombo: combo && `&isCombo=${combo}`,
    };
    const queryParams = Object.values(queryParamsMap).filter(Boolean).join("");
    setQueryParams(queryParams);
  }, [
    startDate,
    endDate,
    bulk,
    subscription,
    status,
    subStatus,
    doctor,
    orderSource,
    orderType,
    owner,
    orderType,
    combo,
  ]);

  useEffect(() => {
    newPage(Number(pageData));
  }, []);

  useEffect(() => {
    fetchMedicalRep();
    fetchConsultRep();
    fetchOperations();
  }, []);

  useEffect(() => {

    if (!initialRender) {
      if (queryParams) {
        navigate(
          `/order-management/allOrder?${queryParams}&pageNumber=${page}`
        );
      } else {
        navigate(`/order-management/allOrder?pageNumber=${page}`);
      }
    }
    setInitialRender(false);
  }, [page, queryParams]);

  useEffect(() => {
    const queryParamsMap = {
      startDate: startDate && `&startDate=${startDate}`,
      endDate: endDate && `&endDate=${endDate}`,
      isBulk: bulk && `&isBulk=${bulk}`,
      isSubscription: subscription && `&isSubscription=${subscription}`,
      status: status && `&status=${status}`,
      subStatus: subStatus && `&subStatus=${subStatus}`,
      doctors: doctor && `&doctors=${doctor}`,
      orderSource: orderSource && `&orderSource=${orderSource}`,
      orderType: repeat && `&orderType=${repeat}`,
      assignedTo: owner && `&assignedTo=${owner}`,
      orderSourceType: orderType && `&orderSourceType=${orderType}`,
      isCombo: combo && `&isCombo=${combo}`,
    };
    const queryParams = Object.values(queryParamsMap).filter(Boolean).join("");
    if (pageData) {
      fetchAllOrder(`pageNumber=${pageData}${queryParams}`);
    }
  }, [pageData, queryParams]);

  useEffect(() => {
    if (ordersData?.data?.length) {
      setActiveId(ordersData?.data[0]?.case_id);
      setDocData(ordersData?.data[0]);
      if(page>ordersData?.pagination?.pageCount){
        newPage(1);
      }
    }
  }, [ordersData?.data]);

  useEffect(() => {
    if (countAssign == 0) {
      return;
    } else {
      const checkedData = data?.filter((item) => {
        return item.checked;
      });

      const fetchCustomerData = checkedData?.map((item) => {
        return {
          case_id: item?.case_id,
          user_id: assign,
          order_id: item?.key,
        };
      });
      postAssignData(fetchCustomerData, setToaster);
    }
  }, [countAssign]);

  const handleDownload = () => {
    fetchOrderDownload(`?pageNumber=${pageData}${queryParams}`, setToaster);
  };

  useEffect(() => {
    if (isEmpty(ordersData)) setData([]);
    else {
      const customerData = ordersData?.data?.map((row) => ({
        key: getValue(row, "id"),
        case_id: getValue(row, "case_id"),
        allOrderName: getValue(row, "case.user.first_name"),
        ghostOrderName: getValue(row, "order_meta.customer.first_name"),
        phone_Number: getValue(row, "case.user.phone_number"),
        ghost_phone_Number: getValue(row, "order_phone_number"),
        orderDisplayId: getValue(row, "order_display_id"),
        orderName: getLineItemsName(row.order_meta?.line_items),
        orderStatus: getValue(row, "status"),
        orderSubStatus: getValue(row, "sub_status"),
        orderSource: getValue(row, "order_source"),
        orderDate: getValue(row, "created_at"),
        count: getValue(row, "count"),
        deliveryDate: getValue(row, "delivery_date"),
        is_subscription: getValue(row, "is_subscription_order"),
        is_bulk_order: getValue(row, "is_bulk_order"),
        tracking_id: getValue(row, "tracking_id"),
        tracking_url: getValue(row, "tracking_url"),
        is_combo: getValue(row, "is_combo"),
        bulk_order_duration: getValue(row, "bulk_order_duration"),
        is_single_order: getValue(row, "is_single_order"),
        order_type: getValue(row, "order_type"),
        assignedTo: getValue(row, "assignment.first_name"),
        owner: getValue(row, "case.assignment.first_name"),
        salesRep: getValue(row, "case.salesRep.first_name"),
        order_meta: getValue(row, "order_meta"),
        doctors: getValue(row, "consult_doctor"),
      }));
      setData(customerData);
    }
  }, [ordersData]);

  const handleAllChange = (event) => {
    if (event.target.checked) {
      setData((prevData) =>
        prevData?.map((item) => ({ ...item, checked: true }))
      );
      setAllFlag(true);
    } else {
      setData((prevData) =>
        prevData?.map((item) => ({ ...item, checked: false }))
      );
      setAllFlag(false);
    }
  };

  const handleChange = (event, itemId) => {
    if (event.target.checked) {
      setData((prevData) =>
        prevData?.map((item) =>
          item?.key === itemId ? { ...item, checked: true } : item
        )
      );
    } else {
      setData((prevData) =>
        prevData?.map((item) =>
          item.key === itemId ? { ...item, checked: false } : item
        )
      );
    }
  };

  const handleAssign = () => {
    setCountAssign(countAssign + 1);
    docData.case_id;
  };

  const content = (item) => {
    return (
      <div>
        <p>
          <strong>Tracking ID</strong>:{" "}
          {item.tracking_id !== null ? item.tracking_id : "None"}
        </p>
        <p>
          <strong>Tracking URL</strong>:{" "}
          {item.tracking_url !== null ? item.tracking_url : "None"}
        </p>
      </div>
    );
  };

  return (
    <CardDiv
      title={
        <div>
          <div className="d-flex justify-content-between align-items-center">
            <div className="fs-2">All orders</div>
            <div>
              <div className="d-flex justify-content-end gap-3">
                <div className="d-flex gap-3">
                  <AssignedOrderFilter
                    medicalReps={medicalData}
                    consultReps={consultData}
                  />
                  <div className="d-flex">
                    <AllOrderAssign
                      medicalReps={medicalData}
                      consultReps={consultData}
                      operationsReps={operationData}
                      assign={assign}
                      setAssign={setAssign}
                    />
                    <Button
                      className={
                        assign
                          ? "btb btn-primary ps-n1"
                          : "disabled btb btn-primary ps-n1"
                      }
                      onClick={handleAssign}
                    >
                      Assign
                    </Button>
                  </div>
                </div>
                <div className="d-flex gap-5 align-items-center">
                  <Button className="btb btn-primary" onClick={handleDownload} disabled={isDownloadDisabled}>
                    Download
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      component={
        <div className="scrollable-container">
          <Row>
            <Col
              md={10}
              style={{
                height: "78vh",
                opacity: showCustomerInFull ? 0 : 1,
                width: showCustomerInFull ? "0" : "40%",
                transition: "width 0.3s ease, opacity 0.3s ease",
                overflow: "hidden",
              }}
            >
              <Row className="border rounded-top mx-2  table-head ">
                <Col md={4} className="d-flex gap-2 py-4 border-end">
                  {
                    <span>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckIndeterminate"
                        onChange={handleAllChange}
                        checked={allFlag ? true : false}
                        style={{ content: "-" }}
                      />
                    </span>
                  }
                  <span className="fw-bold">Customers</span>
                </Col>
                <Col md={6} className="fw-bold text-center py-4">
                  Order Details
                </Col>
              </Row>
              <div
                style={{ height: "62vh", overflowY: "scroll" }}
                className="fw-bold scrollable-container"
              >
                {ordersLoading ? (
                  <PlaceHolderActionable />
                ) : data && data.length === 0 ? (
                  <h1 style={{ textAlign: "center" }}>No data</h1>
                ) : (
                  data &&
                  data.map((item, index) => {
                    let subscriptionPlatform =
                      item?.orderStatus !== "ghost" && item?.is_subscription
                        ? getSubscriptionPlatform(item.order_meta)
                        : "";

                    return (
                      <Row
                        className={`border border-top-0 table-row ${
                          index === data.length - 1 && `rounded-bottom`
                        } ms-2 me-1 `}
                        style={{
                          backgroundColor: item?.checked ? "#A8C7F0" : null,
                        }}
                      >
                        <Col
                          md={4}
                          className="border-end"
                          style={{ background: "#eee" }}
                        >
                          <div className="d-flex flex-column py-2">
                            <div className="d-flex flex-column gap-2">
                              <div className="d-flex flex-row gap-2">
                                <span>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value={item?.key}
                                    id={`flexCheckIndeterminate-${item?.key}`}
                                    onClick={(event) =>
                                      handleChange(event, item?.key)
                                    }
                                    checked={item?.checked}
                                  />
                                </span>
                                <span
                                  className="cursor-pointer text-capitalize text-primary  fs-1"
                                  onClick={() => {
                                    setActiveId(item?.case_id);
                                    setDocData(item);
                                    setLoadComponent(true);
                                  }}
                                >
                                  {item?.allOrderName}
                                </span>
                              </div>
                              <div>
                                {moment(item.orderDate).format(
                                  "DD MMM YYYY, h:mm a"
                                )}
                              </div>
                              {/* <span>
                                {isEmpty(item?.phone_Number)
                                  ? item?.ghost_phone_Number
                                  : item?.phone_Number}
                              </span> */}
                            </div>
                          </div>
                          <div>{item?.user?.phone_number}</div>
                        </Col>
                        <Col md={8} className="text-left">
                          <div className="d-flex align-items-start flex-wrap gap-1 py-2">
                            <div>
                              {item.is_subscription && (
                                <div
                                  className="tooltip-bottom"
                                  title={`Subscription Order ${subscriptionPlatform}`}
                                >
                                  <Tag color="geekblue">S</Tag>
                                </div>
                              )}

                              {item.is_bulk_order && (
                                <div
                                  class="tooltip-bottom"
                                  title={`Bulk Order (${item?.bulk_order_duration} months)`}
                                >
                                  <Tag color="geekblue">B</Tag>
                                </div>
                              )}

                              {item.is_single_order && (
                                <div
                                  class="tooltip-bottom"
                                  title="Single Order"
                                >
                                  <Tag color="green">SO</Tag>
                                </div>
                              )}

                              {item?.is_combo && (
                                <div class="tooltip-bottom" title="Combo Order">
                                  <Tag color="hot">C</Tag>
                                </div>
                              )}
                            </div>
                            {item.count <= 1 ? (
                              <Tag className="text-uppercase" color="gold">
                                NEW
                              </Tag>
                            ) : (
                              <Tag className="text-uppercase" color="green">
                                RO {item.count}
                              </Tag>
                            )}
                            <Tag
                              className="text-uppercase"
                              color="green"
                              style={{ width: "auto" }}
                            >
                              {item.order_type?.replaceAll("_", " ")}
                            </Tag>
                            {item.orderSource && (
                              <Tag
                                className="text-uppercase"
                                color="gold"
                                style={{ width: "auto" }}
                              >
                              {`${item.orderSource.toUpperCase()}  ${get(item, 'order_meta.request_source', null) ? '| OMS' : ''}`}
                              </Tag>
                            )}
                            {item.orderSubStatus && (
                              <Tag className="text-uppercase" color="geekblue">
                                {item.orderSubStatus.toUpperCase()}
                              </Tag>
                            )}
                            <Tag
                              className="text-uppercase text-small"
                              color="geekblue"
                            >
                              <div>
                                <div className="d-flex flex-column">
                                  <div>
                                    {item.orderStatus &&
                                      item.orderStatus.toUpperCase()}{" "}
                                  </div>
                                  <div>
                                    {item.orderStatus === "delivered" &&
                                      !isEmpty(item.deliveryDate) &&
                                      moment(item.deliveryDate).format(
                                        "DD-MMM-YYYY"
                                      )}
                                  </div>
                                </div>
                              </div>
                            </Tag>
                            <Popover
                              placement="top"
                              content={content(item)}
                              trigger="click"
                            >
                              <InfoCircleOutlined />
                            </Popover>
                          </div>
                        </Col>
                        {/* <Col md={3} className="text-left">
                          <div className="text-capitalize">
                            {item?.assignedTo}
                          </div>
                        </Col>
                        <Col md={3} className="text-center">
                          <Col md={12} className="text-center">
                            {item?.doctors
                              ?.map((eachDoctor) => eachDoctor.user.first_name)
                              .join(", ")}
                          </Col>
                        </Col> */}
                      </Row>
                    );
                  })
                )}
              </div>
              <Row>
                <PaginationDiv
                  paginationData={{
                    pageCount: ordersData?.pagination?.pageCount
                      ? ordersData?.pagination?.pageCount
                      : 1,
                    page: page,
                  }}
                  newPage={newPage}
                />
              </Row>
            </Col>
            <Col
              className="p-0 mt-n3 scrollable-container"
              style={{
                height: "78vh",
                width: showCustomerInFull ? "100%" : "56%",
                transition: "width 0.3s ease",
                overflow: "auto",
              }}
            >
            {loadComponent === false
              ?
              <div className="container-fluid d-flex justify-content-center align-items-center min-vh-100">
                <div className=" text-center">
                 <SelectDataToDisplay />
                  <h5 className=" p-2 text-bg-light">Select Data To Display</h5>
                </div>
              </div>
              :
              <ShowCustomer
                caseId={activeId}
                isCaseManagement={"false"}
                showCustomerInFull={showCustomerInFull}
                setShowCustomerInFull={setShowCustomerInFull}
              />
            }
            </Col>
          </Row>
        </div>
      }
    />
  );
}

export default AllOrdersManagement;
